import Vue from 'vue';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import BootstrapVue from 'bootstrap-vue';
import App from './App.vue';
import router from './router.js';
import store from './store.js';

Vue.use(BootstrapVue);

// Modern theme overrides (loaded last to take precedence)
import './custom.css';
import './theme.css';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
